import React from 'react';
import styled from '@emotion/styled';

import { useCurrentUser } from '~/src/common/user';
import { isSSR } from '~/src/common/utilities';
import { useHasMounted } from '~/src/components/hooks';
import {
  StartFreeTrialCTA as StartFreeTrialCTABase,
  StartFreeTrialCTAContainer as StartFreeTrialCTAContainerBase,
} from '~/src/components/StartFreeTrialCTA';
import { breakpoints } from '~/src/styles';

const StartFreeTrialCTAWrapper = styled.div`
  background: white;
`;

const StartFreeTrialCTAContainer = styled.div`
  padding: 40px 16px 60px;
  ${breakpoints.minTablet} {
    padding: 40px 0 60px;
    width: 640px;
    margin: auto;
  }

  ${breakpoints.minDesktop} {
    padding: 48px 0 75px;
  }
`;

export const StartFreeTrialCTA: React.FC = () => {
  /**
       the logic of hiding component is duplication of what internal StartFreeTrialCTABase has.
       We need this to avoid extra paddings.
       This logic should be refactored when we understand
     */

  const { isLoggedIn } = useCurrentUser();

  const { hasMounted } = useHasMounted();
  const isFirstRender = !hasMounted;
  if (isSSR() || isFirstRender || isLoggedIn) {
    return null;
  }
  return (
    <StartFreeTrialCTAContainerBase>
      <StartFreeTrialCTAWrapper>
        <StartFreeTrialCTAContainer>
          <StartFreeTrialCTABase />
        </StartFreeTrialCTAContainer>
      </StartFreeTrialCTAWrapper>
    </StartFreeTrialCTAContainerBase>
  );
};
